"use client";

import { createContext, type RefObject } from "react";

export type SliderContextProps = {
  scrollRef: RefObject<HTMLDivElement | null>;
  registerItem: (element: HTMLDivElement) => () => void;
  scrollPrev: () => void;
  scrollNext: () => void;
  scrollToIndex: (index: number) => void;
  canScrollPrev: boolean;
  canScrollNext: boolean;
  itemCount: number;
  firstVisibleIndex: number;
  dir: "ltr" | "rtl";
};

const SliderContext = createContext<SliderContextProps | null>(null);

export default SliderContext;
